(() => {
  const bag = document.getElementById('GalleryBag');
  if (!bag || typeof bag.showModal !== 'function') return;
  let busy = false;
  let opener;
  const status = bag.querySelector('.bag-status');
  const open = source => {
    if (!bag.open) {
      opener = source || document.activeElement;
      bag.showModal();
      document.body.classList.add('bag-open');
    }
  };
  bag.addEventListener('close', () => {
    document.body.classList.remove('bag-open');
    if (opener?.isConnected) opener.focus();
  });
  const render = html => {
    if (!html) throw new Error(bag.dataset.error);
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('#GalleryBag');
    if (!fresh) throw new Error(bag.dataset.error);
    bag.querySelector('[data-bag-content]').replaceChildren(...fresh.querySelector('[data-bag-content]').childNodes);
    const count = fresh.querySelector('[data-bag-count]').textContent;
    bag.querySelector('[data-bag-count]').textContent = count;
    document.querySelectorAll('.cart-count').forEach(el => { el.textContent = count; });
  };
  const refresh = async () => {
    const url = new URL(bag.dataset.cartUrl, location.origin);
    url.searchParams.set('section_id', bag.dataset.section);
    const response = await fetch(url, { headers: { Accept: 'text/html' }, cache: 'no-store' });
    if (!response.ok) throw new Error(bag.dataset.error);
    render(await response.text());
  };
  const run = async task => {
    if (busy) return;
    busy = true;
    bag.setAttribute('aria-busy', 'true');
    status.textContent = bag.dataset.loading;
    try { await task(); status.textContent = ''; }
    catch (error) { status.textContent = error.message || bag.dataset.error; }
    finally { busy = false; bag.removeAttribute('aria-busy'); }
  };
  const change = (key, quantity, focusId) => run(async () => {
    const response = await fetch(`${bag.dataset.changeUrl}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity, sections: bag.dataset.section, sections_url: location.pathname })
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || bag.dataset.error);
    if (result.sections?.[bag.dataset.section]) render(result.sections[bag.dataset.section]); else await refresh();
    (focusId && document.getElementById(focusId) || bag.querySelector('[data-close-bag]')).focus();
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-open-bag]');
    if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    open(trigger);
    run(refresh);
  });
  bag.addEventListener('click', event => {
    if (event.target.closest('[data-close-bag]')) bag.close();
    if (event.target === bag) {
      const rect = bag.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right) bag.close();
    }
    const remove = event.target.closest('[data-remove-item]');
    if (remove) change(remove.dataset.removeItem, 0);
  });
  bag.addEventListener('change', event => {
    if (!event.target.matches('[data-bag-quantity]')) return;
    if (!event.target.reportValidity()) return;
    change(event.target.dataset.key, Number(event.target.value), event.target.id);
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.product-details form') || !form.querySelector('[name=add]')) return;
    event.preventDefault();
    if (busy) return;
    const button = form.querySelector('[name=add]');
    const data = new FormData(form);
    data.set('sections', bag.dataset.section);
    data.set('sections_url', location.pathname);
    button.disabled = true;
    open(button);
    await run(async () => {
      const response = await fetch(`${bag.dataset.addUrl}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: data });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || bag.dataset.error);
      if (result.sections?.[bag.dataset.section]) render(result.sections[bag.dataset.section]); else await refresh();
    });
    button.disabled = form.querySelector('[data-variant-select]')?.selectedOptions[0]?.dataset.available === 'false';
  });
})();
